export default __webpack_public_path__ + "static/media/d_tunnel.51e27916.png";